export enum UserView {
  SEARCH = 1,
  LIST_ACTIVE = 2,
  LIST_INACTIVE = 3,
  ADD = 4,
  DASHBOARD = 5,
  QUALIFICATION = 6,
  MEMBERSHIP = 7,
  CLUB = 8,
  BEACH = 9,
  LAST_CHANGES = 10,
  REGISTRATION_STATISTICS = 11,
  ADMIN_EDIT = 12,
  BEACH_TALENT = 13,
  ACCESS_CARD = 14,
  EDIT_CONTACT = 15,
}
